import React from "react";
import UnavailableSection from "components/UnavailableSection";

/**
 * Was rendering three hardcoded phone numbers. DCR_OrgMember has no phone list
 * and no phone-number route is exposed on the API - see the client-side
 * equivalent in pages/clients/components/PhoneNumbersList.tsx.
 */
const PhoneNumbersList = () => (
  <UnavailableSection
    title="Phone numbers are not available yet"
    reason="Reading a staff member's phone numbers needs an API route that is not exposed yet."
  />
);

export default PhoneNumbersList;
